import { createSlice } from "@reduxjs/toolkit";
import {PreviousAppointmentsData} from "../../../rtk-apis/patients/patientAppointment"
const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const patientAppointmentSlice = createSlice({
  name: "patientListSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(PreviousAppointmentsData.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(PreviousAppointmentsData.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(PreviousAppointmentsData.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default patientAppointmentSlice.reducer;
